import { render, staticRenderFns } from "./SelectInvoiceStatuses.vue?vue&type=template&id=4b789848"
import script from "./SelectInvoiceStatuses.vue?vue&type=script&lang=js"
export * from "./SelectInvoiceStatuses.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports